/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { PlanActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        plans: state.plans
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getSubscription: () => {
            dispatch(PlanActions.fetchSubscription());
        },
        getPlanDetail: (plan) => {
            dispatch(PlanActions.fetchPlanDetail(plan));
        },
        createSubscription: (plan) => {
            dispatch(PlanActions.createSubscription(plan));
        },
        updateSubscription: (plan) => {
            dispatch(PlanActions.updateSubscription(plan));
        },
        updateAddOns: (addOns) => {
            dispatch(PlanActions.updateAddOns(addOns));
        },
        limitCheck: (level, addOns) => {
            dispatch(PlanActions.limitCheck(level, addOns));
        },
        getPlans: () => {
            dispatch(PlanActions.fetchPlans());
        },
        getInvoices: () => {
            dispatch(PlanActions.fetchInvoices());
        },
        getBillingInfo: () => {
            dispatch(PlanActions.fetchBillingInfo());
        },
        updateBillingInfo: (billingInfo) => {
            dispatch(PlanActions.updateBillingInfo(billingInfo));
        },
        updatePullFreq: (freq) => {
            dispatch(PlanActions.updatePullFreq(freq));
        },
        validateCoupon: (code) => {
            dispatch(PlanActions.validateCoupon(code));
        },
        resetCoupon: () => {
            dispatch(PlanActions.resetCoupon());
        },
        validatePromo: (code) => {
            dispatch(PlanActions.validatePromo(code));
        },
        redeemPromo: (data) => {
            dispatch(PlanActions.redeemPromo(data));
        },
        pauseSubscription: (data) => {
            dispatch(PlanActions.pauseSubscription(data));
        },
        applyCoupon: (data) => {
            dispatch(PlanActions.applyCoupon(data));
        },
        getExpiredPlan: () => {
            dispatch(PlanActions.fetchExpiredPlan());
        },
        clearSnapshot: () => {
            dispatch(PlanActions.clearSnapshot());
        }
	};
}

export default function PlanProvider(Component) {

    class PlanProvider extends React.Component {
        constructor(props) {
            super(props);

            this.isFreeUser = this.isFreeUser.bind(this);
            this.isStarterUser = this.isStarterUser.bind(this);
            this.isBasicUser = this.isBasicUser.bind(this);
            this.isProUser = this.isProUser.bind(this);
            this.isPlusUser = this.isPlusUser.bind(this);
            this.isUltimateUser = this.isUltimateUser.bind(this);
            this.isAgencyUser = this.isAgencyUser.bind(this);
            this.isAgencyPlusUser = this.isAgencyPlusUser.bind(this);
            this.isUpgrade = this.isUpgrade.bind(this);
            this.isTrialUser = this.isTrialUser.bind(this);
            this.isFreeOrTrialUser = this.isFreeOrTrialUser.bind(this);
            this._checkLevels = this._checkLevels.bind(this);
        }

        _checkLevels(levels, level) {
            if (level !== undefined && level !== null) {
                level = parseInt(level, 10);
                return (levels.indexOf(level) !== -1) ? true : false;
            } else if (levels.indexOf(this.props.user.detail.pubLevel) !== -1) {
                return true;
            }
            return false;
        }

        isFreeUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_0, constants.PUB_LEVEL_1];

            return this._checkLevels(levels, level);
        }

        isUltimateUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_3, constants.PUB_LEVEL_7];

            return this._checkLevels(levels, level);
        }

        isProUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_6, constants.PUB_LEVEL_11];

            return this._checkLevels(levels, level);
        }

        isPlusUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_9, constants.PUB_LEVEL_13];

            return this._checkLevels(levels, level);
        }

        isAgencyUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_8, constants.PUB_LEVEL_12];

            return this._checkLevels(levels, level);
        }

        isAgencyPlusUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_10, constants.PUB_LEVEL_14];

            return this._checkLevels(levels, level);
        }

        isBasicUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_15];

            return this._checkLevels(levels, level);
        }

        isStarterUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_16];

            return this._checkLevels(levels, level);
        }

        isTrialUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_17];

            return this._checkLevels(levels, level);
        }

        isFreeOrTrialUser(level) {
            let constants = this.props.app.config.constants,
                levels = [constants.PUB_LEVEL_0, constants.PUB_LEVEL_1, constants.PUB_LEVEL_17];

            return this._checkLevels(levels, level);
        }

        isUpgrade(nextPlan) {

            if (nextPlan === this.props.user.detail.pubLevel) {
                return false;
            }

            if (this.isFreeUser(nextPlan)) {
                return false;
            }

            if (this.isTrialUser() || this.isStarterUser()) {
                return true;
            }

            if (this.isBasicUser() && this.isStarterUser(nextPlan)) {
                return false;
            }

            if (this.isProUser() && (this.isStarterUser(nextPlan) || this.isBasicUser(nextPlan))) {
                return false;
            }

            if (this.isPlusUser() &&
                (this.isStarterUser(nextPlan) ||
                this.isBasicUser(nextPlan) ||
                this.isProUser(nextPlan))) {
                return false;
            }

            if (this.isAgencyUser() &&
                (this.isStarterUser(nextPlan) ||
                this.isBasicUser(nextPlan) ||
                this.isProUser(nextPlan) ||
                this.isPlusUser(nextPlan))) {
                return false;
            }

            if (this.isAgencyPlusUser()) {
                return false;
            }

            return true;

        }

        render() {
            return (
                <Component
                    isFreeUser={this.isFreeUser}
                    isStarterUser={this.isStarterUser}
                    isBasicUser={this.isBasicUser}
                    isProUser={this.isProUser}
                    isPlusUser={this.isPlusUser}
                    isUltimateUser={this.isUltimateUser}
                    isAgencyUser={this.isAgencyUser}
                    isAgencyPlusUser={this.isAgencyPlusUser}
                    isTrialUser={this.isTrialUser}
                    isFreeOrTrialUser={this.isFreeOrTrialUser}
                    isUpgrade={this.isUpgrade}
                    {...this.props}/>
            );
        }
    }

    PlanProvider.displayName = "PlanProvider";

    return connect(mapStateToProps, mapDispatchToProps)(PlanProvider);
};
